module.exports = __webpack_public_path__ + "img/组 1212@2x.0e09387f.png";